import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { API_URL } from "./config";

const DailyScripture = () => {
    const navigate = useNavigate();
    const [verse, setVerse] = useState({
        text: "",
        reference: "",
        date: new Date().toDateString()
    });
    const [loading, setLoading] = useState(true);

    // Function to fetch a random verse from an API
    const fetchDailyVerse = async () => {
        try {
            setLoading(true);

            // First try Bible API
            try {
                const response = await fetch("https://bible-api.com/?random=verse");
                const data = await response.json();

                if (data.text && data.reference) {
                    // Save to local storage with today's date
                    const today = new Date().toDateString();
                    localStorage.setItem('dailyVerse', JSON.stringify({
                        text: data.text,
                        reference: data.reference,
                        date: today
                    }));

                    setVerse({
                        text: data.text,
                        reference: data.reference,
                        date: today
                    });
                    setLoading(false);
                    return;
                }
            } catch (apiError) {
                console.log("Bible API failed, trying backup", apiError);
            }

            // If Bible API fails, use our backup API
            const backupResponse = await fetch(`${API_URL}/verses/daily`);
            const backupData = await backupResponse.json();

            const today = new Date().toDateString();
            localStorage.setItem('dailyVerse', JSON.stringify({
                text: backupData.text || "The Lord is my shepherd; I shall not want.",
                reference: backupData.reference || "Psalm 23:1",
                date: today
            }));

            setVerse({
                text: backupData.text || "The Lord is my shepherd; I shall not want.",
                reference: backupData.reference || "Psalm 23:1",
                date: today
            });
        } catch (error) {
            // Fallback to default verse
            setVerse({
                text: "The Lord is my shepherd; I shall not want.",
                reference: "Psalm 23:1",
                date: new Date().toDateString()
            });
        } finally {
            setLoading(false);
        }
    };

    // Check if we already have today's verse in local storage
    useEffect(() => {
        const savedVerse = localStorage.getItem('dailyVerse');
        const today = new Date().toDateString();

        if (savedVerse) {
            const parsedVerse = JSON.parse(savedVerse);
            if (parsedVerse.date === today) {
                setVerse(parsedVerse);
                setLoading(false);
                return;
            }
        }

        // If no saved verse or it's from a previous day, fetch new one
        fetchDailyVerse();
    }, []);

    const handleRefresh = () => {
        fetchDailyVerse();
    };

    return (
        <div style={{
            padding: '18px',
            marginBottom: '60px',
            // backgroundColor: '#fff',public\skies.jpg
            backgroundImage: `url(${require('./skies.jpg')})`,
            backgroundSize: 'cover',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        }}>
            {/* Header with Back Button */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                marginBottom: '15px',
                position: 'relative'
            }}>
                {/* <button
                    onClick={() => navigate(-1)}
                    style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '50%',
                        marginRight: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background-color 0.2s ease',
                        ':hover': {
                            backgroundColor: '#f0f2f5'
                        }
                    }}
                >
                    <ArrowBackIcon style={{ color: '#1a6363', fontSize: '28px' }} />
                </button> */}
                <h4 style={{
                    flex: 1,
                    textAlign: 'center',
                    fontSize: '19px',
                    color: '#1a6363',
                    fontWeight: '600',
                    margin: 0,
                    // paddingRight: '52px'
                }}>
                    Daily Scripture
                </h4>
            </div>

            {/* Date Display */}
            <div style={{
                width: '100%',
                textAlign: 'center',
                marginBottom: '20px',
                color: '#666',
                fontSize: '14px'
            }}>
                {new Date().toLocaleDateString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })}
            </div>

            {/* Scripture Card */}
            {loading ? (
                <div style={{
                    width: '100%',
                    maxWidth: '500px',
                    height: '200px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#1a6363'
                }}>
                    Loading today's scripture...
                </div>
            ) : (
                <div style={{
                    border: '1px solid #1a6363',
                    borderRadius: '10px',
                    padding: '25px',
                    margin: '10px auto',
                    maxWidth: '500px',
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center'
                }}>
                    <div style={{
                        fontSize: '18px',
                        lineHeight: '1.6',
                        color: '#333',
                        marginBottom: '20px',
                        fontStyle: 'italic'
                    }}>
                        "{verse.text}"
                    </div>
                    <div style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#1a6363',
                        marginBottom: '20px'
                    }}>
                        — {verse.reference}
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '15px',
                        marginTop: '20px'
                    }}>
                        <button
                            onClick={handleRefresh}
                            style={{
                                backgroundColor: '#1a6363',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '5px',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px'
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="23 4 23 10 17 10"></polyline>
                                <polyline points="1 20 1 14 7 14"></polyline>
                                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                            </svg>
                            Refresh Verse
                        </button>

                    </div>
                </div>
            )}

        </div>
    );
};

export default DailyScripture;